import React, { Component } from "react";
import {withRouter } from "react-router-dom";

import "./App.css";

import Routes from "./Routes";
import { Auth } from "aws-amplify";
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import Menu, { SubMenu, Item as MenuItem } from 'rc-menu';
import { Link } from 'react-router-dom';
//import 'rc-menu/assets/index.css';
import "./theme.css";
import swal from 'sweetalert';
import 'sweetalert/dist/sweetalert.css';
import { Button, ButtonGroup, ButtonToolbar} from 'reactstrap';
import SvgIcon from 'react-icons-kit';
import {home} from 'react-icons-kit/icomoon/home'
import WaitingModal from './containers/generics/WaitingModal';
import {forward} from 'react-icons-kit/icomoon/forward';


import {statsDots} from 'react-icons-kit/icomoon/statsDots'
import {office} from 'react-icons-kit/icomoon/office'
import ModalPassword from './containers/generics/ModalPassword';


import {userPlus} from 'react-icons-kit/icomoon/userPlus';
import {lab} from 'react-icons-kit/icomoon/lab';
import {cogs} from 'react-icons-kit/icomoon/cogs';
import {desktop} from 'react-icons-kit/fa/desktop';
import {hospitalO} from 'react-icons-kit/fa/hospitalO';
import {ic_cached} from 'react-icons-kit/md/ic_cached';
import {eyedropper} from 'react-icons-kit/icomoon/eyedropper';
import {users} from 'react-icons-kit/icomoon/users';
import {exit} from 'react-icons-kit/icomoon/exit';
import {user} from 'react-icons-kit/icomoon/user';
import {cog} from 'react-icons-kit/icomoon/cog';

import IdleTimer from 'react-idle-timer';
import $ from 'jquery';
import {fetchRequest} from './libs/fetchRequest';
import { 
	getColumnsList, getLineUnitRequest, getLineWarehouse, functionalCriterial, lookAndFeel, 
	getPermissions, qualityControlCheck,    
	printLabel, specialReports,logout, getUserGeneric, generatePdfImss, generateExcelImss, htmlTemplatesPrintExternal, htmlTemplatePrintDocument, 
	checkPrintType,
	lookAndFeelByHfId,
	unitsCheckExpired
} from "./libs/services";
import ModalSetInfoSession from "./containers/ModalSetInfoSession";
import moment from "moment";
import { convert } from "html-to-text";
import PrintStatusWidget from "./containers/generics/PrintStatusWidget";

var Config = require('./config');
var socket = "";
var session = sessionStorage.getItem('health_facilities_name');

const header = require('./menu.json');

function onOpenChange(value) {
}



class App extends Component {
	constructor(props) {
		super(props);
		this.updatePermissions = this.updatePermissions.bind(this);

		this.handleClick = this.handleClick.bind(this);
		this.generateReport = this.generateReport.bind(this);
		this.reload = this.reload.bind(this);
		this.changePwd = this.changePwd.bind(this);
		this.getLookFeel = this.getLookFeel.bind(this);
		this.onIdle = this.onIdle.bind(this);
		this.getDocumentType = this.getDocumentType.bind(this);
		this.printDocumentTemplate = this.printDocumentTemplate.bind(this);
		this.printDocumentExternal = this.printDocumentExternal.bind(this);
		this.getServices = this.getServices.bind(this);
		this.printLabel = this.printLabel.bind(this);
		this.openSocket = this.openSocket.bind(this);
		this.printPdfReports = this.printPdfReports.bind(this);
		this.printPdfIMSSReports = this.printPdfIMSSReports.bind(this);
		this.printExcelReport = this.printExcelReport.bind(this);
		this.fileDownLoad = this.fileDownLoad.bind(this);
		this.handleLogout = this.handleLogout.bind(this);
		this.setInfoSession = this.setInfoSession.bind(this);
		this.replaceHeader = this.replaceHeader.bind(this);
		this.changePass = this.changePass.bind(this);
		
		
		this.state = {
			isAuthenticated: false,
			isAuthenticating: true,
			task_vital_signs:{},
			task_biometrics:{},
			task_clinic_history:{},
			task_extraction:{},
			task_register:{},
			task_social:{},
			task_general_summary:{},
			task_release_lock:{},
			task_screen_caller:{},
			task_validation_donation:{},
			task_results_donation:{},
			task_lab_antibodies:{},
			task_lab_phenotypes:{},
			task_has_user_profiles:[],
			lab_sections_has_user_profiles:[],
			medical_staff:{},
			task_unit_request:{},
			task_unit_send:{},
			search:"",
			columns:[],
			don_usr_llam:"",
			machine_name:"-------",
			waiting:"",
			task_centrifuge:{},
			task_division:{},
			task_transformation:{},
			task_alicuots:{},
			task_pools:{},
			task_recostitution:{},
			task_cryoprecipitates:{},
			task_discard_units:{},
			permissions:[],

			task_external_bags:{},
			task_donor_samples:{},
			task_sample_results:{},
		
			task_petitions:{},
			task_patient_sample_results:{},
			task_inactive_plasma:{},
			task_unit_entries:{},
			show_menu:{},

			hiddeToReport: false,

			change_version: false,
			api_version:"",
			logo_1:"",
			w_logo1:"",
			logo_2:"",
			w_logo2:"",
			header_document:"",
			w_head:"",
			background_color:"",
			font_color:"",
			icon_color:"",

			task_plasmatic_product:{},
			task_plasmatic_entries:{},
			task_plasmatic_p_storage:{},
			task_plasmatic_p_discard:{},
			task_promotion_campaign:{},
			task_promotion_external_bags:{},
			task_distribution_returned:{},
			line_warehouse:false,
			line_unit_request:false,
			task_samples_reception:{},
			line_distribution_criteria: {},
			task_units_locked:{},
			task_unit_transfer:{},
			task_summary_campaigns:{},

			task_unit_delivered:{},
			task_unit_reserves:{},
			preview_print:{},
			graphics:[],
			supplies_storage:{},
			supplies_entries:{},
			supplies:{},
			supplies_discards:{},
			supplies_output:{},
			expiration_password_date:"",
			old_pwd:"",
			new_pwd:"",
			c_pwd:"",
			expiration_day:{},
			passwordExpired:false,
			passwordChanged:false
		};
	}
    
	
	/* FUNCIONA */
	async handleClick(info){
		var search = info.item.props.search ? info.item.props.search : '';
		var valid = true;

		switch(search){
			case 'logo':
			case 'none':
				valid = false;
				break;
			case 'pass_change':
				valid = false;

				this.changePwd();
				break;
			case 'site_change':
				valid = false;
				this.modal_set_info.handleShow();
				break;
			case 'singout':
				valid = false;
				this.handleLogout();
				break;
			case 'promotion/offers':
				search = 'campaings';
				break;
			case '':
				valid = false;
				this.generateReport();
	
			default:
				valid = true;
				break;
		}

		if(valid){
			this.setState({search:search === 'campaings' ? 'promotion/offers' : search});

			//this.props.history.push('/');
			setTimeout(()=>{
				this.props.history.replace('/'+(search === 'campaings' ? 'promotion/offers' : search));
			}, 0);
			
			if(search !== 'no_search'){
				var columns = 	await getColumnsList(search);
				
				if(columns !== undefined){
					this.setState({columns: columns});
				}				
			}			

		}
		 
	}

	async getServices(){
		
		var preview_print = await functionalCriterial('lab_preview_print');
		if(preview_print !== undefined){
			this.setState({preview_print: preview_print});
		}
		var line_distribution_criteria = await functionalCriterial('line_distribution');
		if(line_distribution_criteria !== undefined){
			this.setState({line_distribution_criteria: line_distribution_criteria});
		}
		var line_unit_request = await getLineUnitRequest();
		if(line_unit_request !== undefined){
			this.setState({line_unit_request: line_unit_request});
		}

		var line_warehouse = await getLineWarehouse();
		if(line_warehouse !== undefined){
			this.setState({line_warehouse: line_warehouse});
		}
		var expiration_day = await functionalCriterial('EXPIRATION_DAYS');
		if(expiration_day !== undefined){
			sessionStorage.removeItem('expiration_day')
			sessionStorage.setItem('expiration_day',expiration_day.value)
			this.setState({expiration_day: expiration_day});
		}
		var request = await functionalCriterial('GEN_MIN_LOG_OUT');
		if(request !== undefined){
			this.idleTimer.reset();
			sessionStorage.setItem("min_logout", request.value);
		}
		var request = await functionalCriterial('DON_REQ_GRH');
		if(request !== undefined){
			this.idleTimer.reset();
			sessionStorage.setItem("don_req_grh", request.value);
		}
	}
	
	componentDidMount() {
		try {
			
			if (sessionStorage.getItem("token")!== undefined && sessionStorage.getItem("token")!== null && sessionStorage.getItem("token")!== "") {
				this.openSocket();
				//this.getLookFeel();
				this.replaceHeader(sessionStorage.getItem('health_facilities_id'));
				this.userHasAuthenticated(true);
				this.updatePermissions();
				this.getServices();
				console.log(sessionStorage.getItem('passwordExpired'));
				if (sessionStorage.getItem('passwordExpired')=='YES') {
					console.log("reload");
					this.checkPasswordExpiration();
				}
				
			}else{
				if(this.props.location.pathname.indexOf('/change_list') === -1 && this.props.location.pathname.indexOf('/caller') === -1){
					this.props.history.push("/login");
				}else{
					this.getLookFeel();
					//this.replaceHeader(sessionStorage.getItem('health_facilities_id'));
				}
			}
		}
		catch(e) {
			if (e !== 'No current user') {
				swal('Error', e,'error');
			}
		}


		this.setState({ isAuthenticating: false });

		if(JSON.parse(sessionStorage.getItem("task_vital_signs") !== null)){
			this.setState({
				task_vital_signs:JSON.parse(sessionStorage.getItem("task_vital_signs")),
				task_biometrics:JSON.parse(sessionStorage.getItem("task_biometrics")),
				task_clinic_history:JSON.parse(sessionStorage.getItem("task_clinic_history")),
				task_extraction:JSON.parse(sessionStorage.getItem("task_extraction")),
				task_register:JSON.parse(sessionStorage.getItem("task_register")),
				task_general_summary:JSON.parse(sessionStorage.getItem("task_general_summary")),
				task_release_lock:JSON.parse(sessionStorage.getItem("task_release_lock")),
				task_screen_caller:JSON.parse(sessionStorage.getItem("task_screen_caller")),
				task_results_donation:JSON.parse(sessionStorage.getItem("task_results_donation")),
				task_validation_donation: JSON.parse(sessionStorage.getItem("task_validation_donation")),
				task_lab_antibodies: JSON.parse(sessionStorage.getItem("task_lab_antibodies")),
				task_lab_phenotypes: JSON.parse(sessionStorage.getItem("task_lab_phenotypes")),
				task_has_user_profiles: JSON.parse(sessionStorage.getItem("task_has_user_profiles")),
				lab_sections_has_user_profiles: JSON.parse(sessionStorage.getItem("lab_sections_has_user_profiles")),
				medical_staff: JSON.parse(sessionStorage.getItem("medical_staff")),
				task_unit_request: JSON.parse(sessionStorage.getItem("task_unit_request")),
				task_unit_send: JSON.parse(sessionStorage.getItem("task_unit_send")),
				task_centrifuge:JSON.parse(sessionStorage.getItem("task_centrifuge")),
				task_division:JSON.parse(sessionStorage.getItem("task_division")),
				task_transformation:JSON.parse(sessionStorage.getItem("task_transformation")),
				task_alicuots:JSON.parse(sessionStorage.getItem("task_alicuots")),
				task_pools:JSON.parse(sessionStorage.getItem("task_pools")),
				task_recostitution:JSON.parse(sessionStorage.getItem("task_recostitution")),
				task_cryoprecipitates:JSON.parse(sessionStorage.getItem("task_cryoprecipitates")),
				task_discard_units:JSON.parse(sessionStorage.getItem("task_discard_units")),
				task_external_bags:JSON.parse(sessionStorage.getItem('task_external_bags')),
				task_donor_samples:JSON.parse(sessionStorage.getItem('task_donor_samples')),
				task_sample_results:JSON.parse(sessionStorage.getItem('task_sample_results')),
				task_petitions:JSON.parse(sessionStorage.getItem('task_petitions')),
				task_patient_sample_results:JSON.parse(sessionStorage.getItem('task_patient_sample_results')),
				task_inactive_plasma:JSON.parse(sessionStorage.getItem('task_inactive_plasma')),
				task_unit_entries:JSON.parse(sessionStorage.getItem('task_unit_entries')),
				task_plasmatic_product:JSON.parse(sessionStorage.getItem('task_plasmatic_product')),
				task_plasmatic_entries:JSON.parse(sessionStorage.getItem('task_plasmatic_entries')),
				task_plasmatic_p_storage:JSON.parse(sessionStorage.getItem('task_plasmatic_p_storage')),
				task_promotion_campaign:JSON.parse(sessionStorage.getItem('task_promotion_campaign')),
				task_promotion_external_bags:JSON.parse(sessionStorage.getItem('task_promotion_external_bags')),
				task_plasmatic_p_discard:JSON.parse(sessionStorage.getItem('task_plasmatic_p_discard')),
				task_units_locked:JSON.parse(sessionStorage.getItem('task_units_locked')),
				task_unit_transfer:JSON.parse(sessionStorage.getItem('task_unit_transfer')),
				task_summary_campaigns:JSON.parse(sessionStorage.getItem("task_general_summary")),
				task_distribution_returned:JSON.parse(sessionStorage.getItem("task_distribution_returned")),
				
			});

		}

	}

	openSocket(){
		console.log('open socket')
		socket= new WebSocket("wss://localhost:2018");

		socket.onerror = (event)=> {
			this.setState({disableStartBtn:true});
			sessionStorage.setItem("machine_name","NULL");
		};

		socket.onopen = (event)=> {
			socket.send("initfp");
		};

		socket.onclose = (e)=>{
			console.log('websocket disconnected:' + e.code + ' ' + e.reason + ' ' + e.wasClean);
		};

		socket.onmessage = (event) => {
			var res = JSON.parse(event.data);
			if(res.MachineName){
				sessionStorage.setItem("machine_name",res.MachineName);
			}

			if(res.Error !== undefined){
		    	swal('¡Error!', res.Error, 'error');
		    }
		}
	}

	componentDidUpdate(){
		setTimeout(()=>{
			$('input').each(function(x){
				$(this).attr('autocomplete', 'off');
			});
		}, 500);
	}

	onIdle(e){
		if(this.props.location.pathname.indexOf('/change_list') === -1 && this.props.location.pathname.indexOf('/caller_list') === -1 && this.props.location.pathname.indexOf('/login') === -1 ){
			if(sessionStorage.getItem('user_name') !== 'ENCUESTAS'){
				this.handleLogout();
			}			
		}
	}

	async getLookFeel(){
		var response = await lookAndFeel();

		if(response !== undefined && response !== null){
			var R_b = this.hexToR(response.background_color);
			var G_b = this.hexToG(response.background_color);
			var B_b = this.hexToB(response.background_color);

			var R_f = this.hexToR(response.font_color1);
			var G_f = this.hexToG(response.font_color1);
			var B_f = this.hexToB(response.font_color1);

			if(response.icon_color !== null){
				var R_i = this.hexToR(response.icon_color);
				var G_i = this.hexToG(response.icon_color);
				var B_i = this.hexToB(response.icon_color);
			}else{
				var R_i = this.hexToR('#bababa');
				var G_i = this.hexToG('#bababa');
				var B_i = this.hexToB('#bababa');
			}

			document.title = response.page_name !== undefined ? response.page_name : 'HAP';


			this.setState({
				logo_1:'data:image/jpeg;base64,'+response.logo1, //'data:image/jpeg;base64,'+response.logo1,
				logo_2:'data:image/jpeg;base64,'+response.logo2,
				header_document:'data:image/jpeg;base64,'+response.header_document,
				background_color:R_b+','+G_b+','+B_b,
				font_color:R_f+','+G_f+','+B_f,
				icon_color:R_i+','+G_i+','+B_i,
				change_version: response.change_version,
				api_version: response.change_version ? response.dsbb_version : "",
			});

			var img = document.getElementById("logo_img")
			if(img !== null){
				img.getAttribute("src");
				setTimeout(function(){

					if(img.width > img.height){
						if(img.width === 100){
							document.documentElement.style.setProperty('--w-image', '55px');
							document.documentElement.style.setProperty('--w-img-home', '15%');
						}else{
							document.documentElement.style.setProperty('--w-image', '100px');
							document.documentElement.style.setProperty('--w-img-home', '40%');
						}

					}else if(img.width < img.height){
						document.documentElement.style.setProperty('--w-image', '40px');
						document.documentElement.style.setProperty('--w-img-home', '13%');

					}else{
						document.documentElement.style.setProperty('--w-image', '45px');
						document.documentElement.style.setProperty('--w-img-home', '15%');
					}
				},0)
			}
				
			const dimensions = this.getImageDimensions('data:image/jpeg;base64,'+response.logo1);
			const dimensions2 = this.getImageDimensions('data:image/jpeg;base64,'+response.logo2);
			const head_dimentions = this.getImageDimensions('data:image/png;base64,'+response.header_document)
			
			var w_logo1 = '', w_logo2 = '';

			dimensions.then((d)=>{
				if(d.w > d.h){
					this.setState({w_logo1: 100});
				}else{
					this.setState({w_logo1: 50});
				}
			})

			dimensions2.then((d)=>{
				if(d.w > d.h){
					this.setState({w_logo2: 100});
				}else{
					this.setState({w_logo2: 50});
				}
			})
			
			head_dimentions.then((d)=>{
				if(d.w > d.h){
					this.setState({w_head: 500});
				}else{
					this.setState({w_head: 50});
				}
			})

			document.documentElement.style.setProperty('--primary', R_b+','+G_b+','+B_b);
			document.documentElement.style.setProperty('--font', R_f+','+G_f+','+B_f);
			document.documentElement.style.setProperty('--icon', R_i+','+G_i+','+B_i);

			if(document.getElementsByClassName("rc-menu").length > 0){
				document.getElementsByClassName("rc-menu")[0].style.backgroundColor = 'var(--bg-menu)';
				document.getElementsByClassName("rc-menu")[0].style.color = 'var(--color-menu)';
			}
		}
	}

	async replaceHeader(id){
		var response = await lookAndFeelByHfId(id);
		if(response){
			var R_b = this.hexToR(response.background_color);
			var G_b = this.hexToG(response.background_color);
			var B_b = this.hexToB(response.background_color);

			var R_f = this.hexToR(response.font_color1);
			var G_f = this.hexToG(response.font_color1);
			var B_f = this.hexToB(response.font_color1);

			if(response.icon_color !== null){
				var R_i = this.hexToR(response.icon_color);
				var G_i = this.hexToG(response.icon_color);
				var B_i = this.hexToB(response.icon_color);
			}else{
				var R_i = this.hexToR('#bababa');
				var G_i = this.hexToG('#bababa');
				var B_i = this.hexToB('#bababa');
			}

			document.title = response.page_name !== undefined ? response.page_name : 'HAP';


			this.setState({
				logo_1:'data:image/jpeg;base64,'+response.logo1, //'data:image/jpeg;base64,'+response.logo1,
				logo_2:'data:image/jpeg;base64,'+response.logo2,
				header_document:'data:image/jpeg;base64,'+response.header_document,
				background_color:R_b+','+G_b+','+B_b,
				font_color:R_f+','+G_f+','+B_f,
				icon_color:R_i+','+G_i+','+B_i,
				change_version: response.change_version,
				api_version: response.change_version ? response.dsbb_version : "",
			});

			var img = document.getElementById("logo_img")
			if(img !== null){
				img.getAttribute("src");
				setTimeout(function(){

					if(img.width > img.height){
						if(img.width === 100){
							document.documentElement.style.setProperty('--w-image', '55px');
							document.documentElement.style.setProperty('--w-img-home', '15%');
						}else{
							document.documentElement.style.setProperty('--w-image', '100px');
							document.documentElement.style.setProperty('--w-img-home', '40%');
						}

					}else if(img.width < img.height){
						document.documentElement.style.setProperty('--w-image', '40px');
						document.documentElement.style.setProperty('--w-img-home', '13%');

					}else{
						document.documentElement.style.setProperty('--w-image', '45px');
						document.documentElement.style.setProperty('--w-img-home', '15%');
					}
				},0)
			}
				
			const dimensions = this.getImageDimensions('data:image/jpeg;base64,'+response.logo1);
			const dimensions2 = this.getImageDimensions('data:image/jpeg;base64,'+response.logo2);
			const head_dimentions = this.getImageDimensions('data:image/png;base64,'+response.header_document)
			
			var w_logo1 = '', w_logo2 = '';

			dimensions.then((d)=>{
				if(d.w > d.h){
					this.setState({w_logo1: 100});
				}else{
					this.setState({w_logo1: 50});
				}
			})

			dimensions2.then((d)=>{
				if(d.w > d.h){
					this.setState({w_logo2: 100});
				}else{
					this.setState({w_logo2: 50});
				}
			})
			
			head_dimentions.then((d)=>{
				if(d.w > d.h){
					this.setState({w_head: 500});
				}else{
					this.setState({w_head: 50});
				}
			})

			document.documentElement.style.setProperty('--primary', R_b+','+G_b+','+B_b);
			document.documentElement.style.setProperty('--font', R_f+','+G_f+','+B_f);
			document.documentElement.style.setProperty('--icon', R_i+','+G_i+','+B_i);

			if(document.getElementsByClassName("rc-menu").length > 0){
				document.getElementsByClassName("rc-menu")[0].style.backgroundColor = 'var(--bg-menu)';
				document.getElementsByClassName("rc-menu")[0].style.color = 'var(--color-menu)';
			}
		}
	}

	getImageDimensions(file) {
	  	return new Promise (function (resolved, rejected) {
	    	var i = new Image()
	    	i.src = file
	    	
	    	i.onload = function(){
	      		resolved({w: i.width, h: i.height})
	    	};
	  	})
	}

	hexToR(h) {return parseInt((this.cutHex(h)).substring(0,2),16)}
	hexToG(h) {return parseInt((this.cutHex(h)).substring(2,4),16)}
	hexToB(h) {return parseInt((this.cutHex(h)).substring(4,6),16)}
	cutHex(h) {return (h.charAt(0)=="#") ? h.substring(1,7):h}

	async updatePermissions(){
		var data = await getPermissions();
		if(data !== undefined){
			if(data.medical_staff !== null){
				var medical = {
					id:data.medical_staff.id,
					names: data.medical_staff.names,
					lastname1: data.medical_staff.lastname1,
					lastname2: data.medical_staff.lastname2
				};
			}else{
				var medical = {};
			}
			sessionStorage.setItem('expiration_password_date',data.expiration_password_date);
			this.setState({
				permissions:data.permissions_user,
				task_has_user_profiles: data.task_has_user_profiles,
				lab_sections_has_user_profiles: data.lab_sections_has_user_profiles,
				medical_staff: medical,
				show_menu: data.user_menu_options,
				api_version: this.state.change_version ? this.state.api_version : data.api_version,
				graphics: data.dashboard_graphics,
				expiration_password_date: data.expiration_password_date
			});

			var permiso_control = data.task_has_user_profiles.findIndex(obj => obj === 'QUALITY_CONTROL');
			if(permiso_control !== -1 && sessionStorage.getItem("interfaz") === "web"){
				var response = await qualityControlCheck();
				if(response !== undefined){
					if(response.length > 0 
						&& !this.state.passwordExpired
						){

						var msg = "<label>Se tienen que realizar controles de control de calidad a los siguientes componentes:</label><div style='text-align:left'> ";
						msg += '<table class="table"><thead><tr><th>Componente<th><th>Cantidad</th></tr></thead><tbody>'
						response.map((res)=>{
							msg += '<tr><td>'+res.component+'</td><td>'+res.total+'</td></tr>';
						})
						msg += '</tbody></table>';
						swal({
							title: 'Alerta',
							html:true,
							text: msg,
							type: 'warning',
							showCancelButton: true,
							confirmButtonColor: '#DD6B55',
							confirmButtonText: '¡Ir!',
							cancelButtonText: '¡Cancelar!',
							//closeOnConfirm: true,
							closeOnCancel: true
						}, (isConfirm)=>{
							if(isConfirm === true){
								this.props.history.push('/quality_control');
								
							}
						});
					}
				}
			}
			
			sessionStorage.setItem("task_has_user_profiles", JSON.stringify(data.task_has_user_profiles));
			sessionStorage.setItem("lab_sections_has_user_profiles", JSON.stringify(data.lab_sections_has_user_profiles));
			sessionStorage.setItem("medical_staff", JSON.stringify(medical));
			
			if(data.permissions_user !== null){
				this.setState({
					task_vital_signs:this.getTask('vital_signs'),
					task_biometrics:this.getTask('CAPTURE_BIOMETRIC'),
					task_clinic_history:this.getTask('clinic_history'),
					task_extraction:this.getTask('extraction'),
					task_register:this.getTask('register'),
					task_general_summary:this.getTask('general_summary'),
					task_release_lock:this.getTask('release_lock'),
					task_screen_caller:this.getTask('screen_caller'),
					task_results_donation: this.getTask('results_donation'),
					task_validation_donation: this.getTask('validation_donation'),
					task_lab_antibodies: this.getTask('LAB_ANTIBODIES'),
					task_lab_phenotypes: this.getTask("LAB_PHENOTYPES"),
					task_unit_request: this.getTask('UNIT_REQUEST'),
					task_unit_send: this.getTask('UNIT_SEND'),
					task_centrifuge:this.getTask('CENTRIFUGE'),
					task_division:this.getTask('DIVISION'),
					task_transformation:this.getTask('TRANSFORMATION'),
					task_alicuots:this.getTask('ALICUOTS'),
					task_pools:this.getTask('POOLS'),
					task_recostitution:this.getTask('RECONSTITUTION'),
					task_cryoprecipitates:this.getTask('CRYOPRECIPITATES'),
					task_discard_units:this.getTask('DISCARD_UNITS'),
					
					task_external_bags:this.getTask('external_bags'),
					task_donor_samples:this.getTask('donor_samples'),
					task_sample_results:this.getTask('sample_results'),
					task_petitions:this.getTask('petitions'),
					task_patient_sample_results:this.getTask('patient_sample_results'),
					task_unit_entries:this.getTask('unit_entries'),
					task_plasmatic_product:this.getTask('PRODUCTS'),
					task_plasmatic_entries:this.getTask('ENTRIES'),
					task_plasmatic_p_storage:this.getTask('P_STORAGE'),
					task_plasmatic_p_discard:this.getTask('PLAS_DISCARDS'),
					task_promotion_campaign:this.getTask('CAMPAIGNS'),
					task_promotion_external_bags:this.getTask('BAG_ENTRIES_PROM'),
					task_units_locked:this.getTask('units_locked'),
					task_unit_transfer:this.getTask('unit_transfer'),
					task_summary_campaigns:this.getTask('summary_campaigns'),
					task_unit_delivered:this.getTask('unit_delivered'),
					task_unit_reserves:this.getTask('unit_reserves'),
					task_distribution_returned: this.getTask('distribution_returned'),
					task_samples_reception: this.getTask('samples_reception'),
					//Insumos
					supplies_storage: this.getTask('SUP_WAREHOUSE'),
					supplies_discards: this.getTask("SUP_DISCARDS"),
					supplies_entries: this.getTask("SUP_ENTRIES"),
					supplies: this.getTask("SUP_SUPPLIES"),
					supplies_output: this.getTask("SUP_EXIT")
				});
			}
		}
	}

	getTask(task_key){
		var res = {};

		res.create = this.existTask(task_key,'create'); 
		res.read = this.existTask(task_key,'read'); 
		res.update = this.existTask(task_key,'update'); 
		res.delete = this.existTask(task_key,'delete'); 
		switch(task_key){
			case 'vital_signs':
				sessionStorage.setItem("task_vital_signs", JSON.stringify(res));
				break;
			case 'CAPTURE_BIOMETRIC':
				sessionStorage.setItem("task_biometrics", JSON.stringify(res));
				break;
			case 'clinic_history':
				sessionStorage.setItem("task_clinic_history", JSON.stringify(res));
				break;
			case 'extraction':
				sessionStorage.setItem("task_extraction", JSON.stringify(res));
				break;
			case 'register':
				sessionStorage.setItem("task_register", JSON.stringify(res));
				break;
			case 'general_summary':
				sessionStorage.setItem('task_general_summary', JSON.stringify(res));
				break;
			case 'release_lock':
				sessionStorage.setItem("task_release_lock", JSON.stringify(res));
				break;
			case 'screen_caller':
				sessionStorage.setItem("task_screen_caller", JSON.stringify(res));
				break;
			case 'results_donation':
				sessionStorage.setItem("task_results_donation", JSON.stringify(res));
				break;
			case 'validation_donation':
				sessionStorage.setItem("task_validation_donation", JSON.stringify(res));
				break;
			case 'LAB_ANTIBODIES':
				sessionStorage.setItem("task_lab_antibodies", JSON.stringify(res));
				break;
			case 'LAB_PHENOTYPES':
				sessionStorage.setItem("task_lab_phenotypes", JSON.stringify(res));
				break;
			case 'UNIT_REQUEST':
				sessionStorage.setItem("task_unit_request", JSON.stringify(res));
				break;
			case 'UNIT_SEND':
				sessionStorage.setItem("task_unit_send", JSON.stringify(res));
				break;
			case 'CENTRIFUGE':
				sessionStorage.setItem("task_centrifuge", JSON.stringify(res));
				break;
			case 'DIVISION':
				sessionStorage.setItem("task_division", JSON.stringify(res));
				break;
			case 'TRANSFORMATION':
				sessionStorage.setItem("task_transformation", JSON.stringify(res));
				break;
			case 'ALICUOTS':
				sessionStorage.setItem("task_alicuots", JSON.stringify(res));
				break;
			case 'POOLS':
				sessionStorage.setItem("task_pools", JSON.stringify(res));
				break;
			case 'RECONSTITUTION':
				sessionStorage.setItem("task_recostitution", JSON.stringify(res));
				break;
			case 'CRYOPRECIPITATES':
				sessionStorage.setItem("task_cryoprecipitates", JSON.stringify(res));
				break;
			case 'DISCARD_UNITS':
				sessionStorage.setItem("task_discard_units", JSON.stringify(res));
				break;
			
			case 'external_bags':
				sessionStorage.setItem("task_external_bags", JSON.stringify(res));
				break;
			case 'donor_samples':
				sessionStorage.setItem("task_donor_samples", JSON.stringify(res));
				break;
			case 'sample_results':
				sessionStorage.setItem("task_sample_results", JSON.stringify(res));
				break;
			case 'WAREHOUSE_UNITS':
				sessionStorage.setItem("task_warehouse_units", JSON.stringify(res));
				break;
			case 'TRACEABILITY_DONATIONS':
				sessionStorage.setItem("task_traceability_donations", JSON.stringify(res));
				break;
			case 'TRACEABILITY_UNITS':
				sessionStorage.setItem("task_traceability_units", JSON.stringify(res));
				break;
			case 'STORE_UNITS':
				sessionStorage.setItem("task_store_units", JSON.stringify(res));
				break;
			case 'petitions':
				sessionStorage.setItem("task_petitions", JSON.stringify(res));
				break;
			case 'patient_sample_results':
				sessionStorage.setItem("task_patient_sample_results", JSON.stringify(res));
				break;
			case 'INACTIVE_PLASMA':
				sessionStorage.setItem("task_inactive_plasma", JSON.stringify(res));
				break;
			case 'unit_entries':
				sessionStorage.setItem('task_unit_entries', JSON.stringify(res));
				break;
			case 'PRODUCTS' :
				sessionStorage.setItem('task_plasmatic_product', JSON.stringify(res));
				break;
			case 'ENTRIES' :
				sessionStorage.setItem('task_plasmatic_entries', JSON.stringify(res));
				break;
			case 'P_STORAGE' :
				sessionStorage.setItem('task_plasmatic_p_storage', JSON.stringify(res));
				break;
			case 'CAMPAIGNS' :
				sessionStorage.setItem('task_promotion_campaign', JSON.stringify(res));
				break;
			case 'BAG_ENTRIES_PROM' :
				sessionStorage.setItem('task_promotion_external_bags', JSON.stringify(res));
				break;
			case 'PLAS_DISCARDS' :
				sessionStorage.setItem('task_plasmatic_p_discard', JSON.stringify(res));
				break;
			case 'units_locked':
				sessionStorage.setItem('task_units_locked', JSON.stringify(res));
				break;
			case 'unit_transfer':
				sessionStorage.setItem('task_unit_transfer', JSON.stringify(res));
				break;
			case 'summary_campaigns':
				sessionStorage.setItem('task_summary_campaigns', JSON.stringify(res));
				break;
			case 'distribution_returned':
				sessionStorage.setItem('task_distribution_returned', JSON.stringify(res));
				break;
		}
		

		return res;
	}

	existTask(task_key, action){
		var res = false;
		for(var i =0; i < this.state.permissions.length;i++){
			if(this.state.permissions[i][0].submenu_key.toUpperCase() === task_key.toUpperCase()){

				for(var j =0; j < this.state.permissions[i].length;j++){

					if(this.state.permissions[i][j].label === action.toUpperCase()){
						res = true;
					}
				}
				break;
			}
		}

		return res;
	}

	userHasAuthenticated = authenticated => {
		this.setState({ isAuthenticated: authenticated });
	}

	async handleLogout(event){
		await logout();
		
		if(sessionStorage.getItem("generic_session_id") !== null){
			var generic = await getUserGeneric();
			if(generic !== undefined){
				sessionStorage.setItem("token", ""); 
				this.userHasAuthenticated(false);
				this.props.history.push("/login");
			}
			
		}else{
			await Auth.signOut();
			localStorage.clear();
			sessionStorage.clear();
			socket.close();
			this.userHasAuthenticated(false);
			this.props.history.push("/login");
			
		}	
	};

	goHome = async event => {
		this.props.history.push("/transfusional_control");
	};

	generateReport(){
		if(this.state.hiddeToReport){
			this.setState({
				hiddeToReport:false
			});
			document.getElementsByClassName("rc-menu")[0].style.backgroundColor = 'var(--bg-menu)';
			document.getElementsByClassName("rc-menu")[0].style.color = 'var(--color-menu)';
			document.documentElement.style.setProperty('--title-color', 'rgba(var(--primary), 0.80)');
			
		}else{
			this.setState({
				hiddeToReport:true
			});

			document.getElementsByClassName("rc-menu")[0].style.backgroundColor = 'var(--bg-active)';
			document.getElementsByClassName("rc-menu")[0].style.color = 'var(--color-active)';
			document.documentElement.style.setProperty('--title-color', 'var(--color-active)');
			
		}
			
		this.props.history.push('/');
	}

	reload(){
		this.setState({
			hiddeToReport: true
		});

		setTimeout(()=>{
			document.getElementsByClassName("rc-menu")[0].style.backgroundColor = 'var(--bg-active)';
			document.getElementsByClassName("rc-menu")[0].style.color = 'var(--color-active)';
			document.documentElement.style.setProperty('--title-color', 'var(--color-active)');
		}, 8000);
	}

	changePwd(){
		this.modal_pwd.handleShow();
	}

	async getDocumentType(type){
		var response = await checkPrintType(type);
		
		if(response !== undefined){
			return response;
		}
	}

	openFileNewWindow(response){
		var fileURL = URL.createObjectURL(response);
		window.open(fileURL);
	}

	directPrint(response, type){
		var reader = new FileReader();
		reader.readAsDataURL(response); 
		reader.onloadend = function() {
			var base64data = reader.result;  
			var aux = base64data.split(',');
			socket.send('{"Operacion":"print", "Type":"'+type+'", "File": "'+aux[1]+'"}');
		}
	}

	async printDocumentTemplate(obj, print){
		var response = await htmlTemplatePrintDocument(obj);

		if(response !== undefined){
			if(print){
				this.directPrint(response, 'laboratory');
			}else{
				this.openFileNewWindow(response);
			}

			return response;
		}
	}

	async printDocumentExternal(obj, print){
		console.log(obj, print);
		var response = await htmlTemplatesPrintExternal(obj);
console.log(response)
		this.waiting_modal.handleClose();

		if(response !== undefined){
			if(print){
				this.directPrint(response, 'laboratory');
			}else{
				this.openFileNewWindow(response);
			}

			return response;
		}
	}

	async printLabel(obj, print){
		var response = await printLabel(obj);

		if(response !== undefined){
			if(print){
				this.directPrint(response, 'label_sample_patients');
			}else{
				this.openFileNewWindow(response);
			}

			return true;
		}
		
	}

	async printPdfReports(obj){
		var response = await specialReports(obj);

		if(response !== undefined){
			this.openFileNewWindow(response);
		}
	}

	async printPdfIMSSReports(type, obj){
		var response = await generatePdfImss(type, obj, this.waiting_modal);

		if(response !== undefined){
			this.openFileNewWindow(response);
		}
	}

	async printExcelReport(name, type, obj){
		var response = await generateExcelImss(type, obj, this.waiting_modal);

		if(response !== undefined){
			this.fileDownLoad(name, '.XLSX', 'application/vnd.ms-excel', response);
		}
	}

	fileDownLoad(name, extension, type, message){
		var blob = new Blob([message], {type: type});
        var downloadUrl = URL.createObjectURL(blob);
        var a = document.createElement("a");
        a.href = downloadUrl;
        a.download = name+extension;
        document.body.appendChild(a);
        a.click();
	}

	printPdfReports(obj){
		this.waiting_modal.handleShow('Generando...');
		fetch(Config.default.apiGateway.URL+'special_reports',{
			method:'POST',
			body:JSON.stringify(obj),
			responseType: 'blob',
			headers: new Headers({
				'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
				'Accept'		: 'application/json',
				'Content-Type'	: 'application/json'
			})
		}).then(res => {
			this.waiting_modal.handleClose();
			if(res.ok){
				return res.blob();
			}else{
				res.text().then((msg)=>{
					swal('Error', msg, 'error');
				});
			}
		}).then(response => {
			if(response !== undefined){
				var fileURL = URL.createObjectURL(response);
				window.open(fileURL);
			}
		})
	}

	setInfoSession(health_facilities_id,health_facilities_name, ip, change){
		sessionStorage.setItem("health_facilities_id", health_facilities_id);
		sessionStorage.setItem("health_facilities_name", health_facilities_name);
		sessionStorage.setItem("ip", ip);

		unitsCheckExpired(health_facilities_id);
	
		this.startSession(change);
		if (sessionStorage.getItem('passwordExpired') =='NO') {
			//this.checkPasswordExpiration();
		}
		
	}

	async startSession(change){
		this.userHasAuthenticated(true);
		var expiration_day = await functionalCriterial('EXPIRATION_DAYS');
		if(expiration_day !== undefined){
			sessionStorage.removeItem('expiration_day')
			sessionStorage.setItem('expiration_day',expiration_day.value)
			this.setState({expiration_day: expiration_day});
		}
		var response = await functionalCriterial('GEN_MIN_LOG_OUT');

		if(response !== undefined){
			sessionStorage.setItem("min_logout", response.value);
		}

		this.updatePermissions();
		//this.getLookFeel();
		this.replaceHeader(sessionStorage.getItem('health_facilities_id'));
		this.openSocket();
		this.getServices();
		if(sessionStorage.getItem("user_type") === "USER_HANDHELD"){
			if(sessionStorage.getItem('interfaz') === 'web'){
				
				if(change){
					window.location.reload();
				}else{
					this.props.history.push("/");  
				}
				
			}else{
				this.props.history.push("/transfusional_control");
			}
		
		}else{
			
			if(change){
				console.log("si tiene change");
				window.location.reload();
				this.checkPasswordExpiration();
			}else{
				console.log("else del change tiene change");
				this.props.history.push("/"); 
				this.checkPasswordExpiration();
			}
		}
			
	}
	isValidForm() {
	    const inputs = document.querySelectorAll('input');
	    let isFormValid = true;
	    inputs.forEach(input => {
	    	if(input.required){
		      	const isInputValid = this.showInputError(input.name);
		      	if (!isInputValid) {
		        	isFormValid = false;
		    	}
		  	}
	    });	  
	    
	    return isFormValid;
	}
	showInputError(refName) {
		const control = document.getElementById(refName);
		
		if(control.value === ""){
			if(control !== null){
	            control.classList.add('error');
	        }
			return false;
		}else{
			if(control.className.includes('error')){
				control.classList.remove('error');
			}
			return true;
		}
	}
	changePass(){
		if(this.state.new_pwd.localeCompare(this.state.c_pwd) !== -1){
			document.getElementById('new_pwd').classList.remove('error');
			document.getElementById('c_pwd').classList.remove('error');
			var password = btoa(this.state.old_pwd);
			password = password.split("").reverse().join("");

			if(this.isValidForm()){
				this.waiting_modal.handleShow('Cambiando...');
				fetch(Config.default.apiGateway.URL+'users/change_password?old_pwd='+password+
					'&new_pwd='+this.state.new_pwd,{
					method: 'POST',
					headers: new Headers({
						'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
						'Accept'		: 'application/json',
						'Content-Type'	: 'application/json'
					})
				}).then(res => {
					this.waiting_modal.handleClose();
					if(res.ok){
						return res.json();
					}else{
						res.text().then((msg)=>{
							swal('Error', msg, 'error');
						});
					}
				}).then(response => {
					if(response !== undefined){
						swal('Success', 'Contraseña Actualizada Correctamente, es necesario cerrar sesión', 'success');
						//this.handleClose();
						//this.handleLogout();
						this.setState({passwordExpired:false})
						//window.location.reload();
						//this.props.history.push("/");
						//window.location.reload();
					}
				})
			}else{
				swal('Error', 'Campos Incompletos', 'error');
			}
		}else{
			document.getElementById('new_pwd').classList.add('error');
			document.getElementById('c_pwd').classList.add('error');
			swal('Error', 'Las Contraseñas deben coincidir', 'error');
		}
			
			
	}

	async checkPasswordExpiration (){
		this.waiting_modal.handleShow('Validando contraseña no expirada');
		var expiration_day = await functionalCriterial('EXPIRATION_DAYS');
		if(expiration_day !== undefined){
			console.log(expiration_day.value)
			sessionStorage.removeItem('expiration_day')
			sessionStorage.setItem('expiration_day',expiration_day.value)
			this.setState({expiration_day: expiration_day});
		}
		var data = await getPermissions();
		if (data.expiration_password_date != null) {
			console.log(data.expiration_password_date)
			sessionStorage.removeItem('expiration_password_date');
			sessionStorage.setItem('expiration_password_date',data.expiration_password_date);
		
		//console.log(sessionStorage.getItem('expiration_password_date'))
		if (sessionStorage.getItem('expiration_password_date') !=null) {
			const currentDate = new Date();
			//currentDate.setDate(currentDate.getDate()+3)
const parsedDate = new Date(sessionStorage.getItem('expiration_password_date'));
    parsedDate.setHours(0, 0, 0, 0); // Set hours, minutes, seconds, and milliseconds to 0
    parsedDate.setDate(parsedDate.getDate() + parseInt(sessionStorage.getItem('expiration_day')));
	console.log(moment(currentDate).format('DD/MM/YYYY') , moment(parsedDate).format('DD/MM/YYYY'))
	console.log(currentDate > parsedDate)
    if (currentDate > parsedDate) {
		console.log("expired")
		//this.changePwd();
      this.setState({ passwordExpired: true });
	  //this.setState({passwordChanged:true})
	  sessionStorage.setItem('passwordExpired','YES');
	  this.waiting_modal.handleClose();
	  this.props.history.push("/changedPassword"); 
	  
    } else {
		console.log("not expired")
      this.setState({ passwordExpired: false });
	  sessionStorage.setItem('passwordExpired','NO');
	  //this.setState({passwordChanged:false})
	  this.waiting_modal.handleClose();
	  this.props.history.push("/"); 
    }
		}
	}else{
		console.log("expiration_passwoord_date not set");
		this.setState({ passwordExpired: true });
	  //this.setState({passwordChanged:true})
	  sessionStorage.setItem('passwordExpired','YES');
	  this.waiting_modal.handleClose();
	  this.props.history.push("/changedPassword"); 
	}
  }
  handleChange(e){
	this.setState({
	  [e.target.name]: e.target.value
	});
}

	render() {
		const childProps = {
			preview_print:this.state.preview_print,
			directPrint: this.directPrint,
			openFileNewWindow: this.openFileNewWindow,
			replaceHeader: this.replaceHeader,
			isAuthenticated: this.state.isAuthenticated,
			setInfoSession: this.setInfoSession,
			userHasAuthenticated: this.userHasAuthenticated,
			task_vital_signs:this.state.task_vital_signs,
			task_biometrics:this.state.task_biometrics,
			task_clinic_history:this.state.task_clinic_history,
			task_extraction:this.state.task_extraction,
			task_register:this.state.task_register,
			task_release_lock:this.state.task_release_lock,
			task_screen_caller:this.state.task_screen_caller,
			task_general_summary:this.state.task_general_summary,
			task_results_donation:this.state.task_results_donation,
			task_validation_donation:this.state.task_validation_donation,
			task_lab_antibodies:this.state.task_lab_antibodies,
			task_lab_phenotypes:this.state.task_lab_phenotypes,
			task_has_user_profiles: this.state.task_has_user_profiles || JSON.parse(sessionStorage.getItem("task_has_user_profiles")),
			lab_sections_has_user_profiles: this.state.lab_sections_has_user_profiles,
			medical_staff: this.state.medical_staff,
			task_unit_request: this.state.task_unit_request,
			task_unit_send: this.state.task_unit_send,
			updatePermissions:this.updatePermissions,
			columns:this.state.columns,
			search: this.state.search,
			don_usr_llam:this.state.don_usr_llam,
			waiting: this.waiting_modal,
			task_centrifuge:this.state.task_centrifuge,
			task_division:this.state.task_division,
			task_transformation:this.state.task_transformation,
			task_alicuots:this.state.task_alicuots,
			task_pools:this.state.task_pools,
			task_recostitution:this.state.task_recostitution,
			task_cryoprecipitates:this.state.task_cryoprecipitates,
			task_discard_units:this.state.task_discard_units,
			task_external_bags:this.state.task_external_bags,
			task_donor_samples:this.state.task_donor_samples,
			task_sample_results:this.state.task_sample_results,
			task_petitions:this.state.task_petitions,
			task_patient_sample_results:this.state.task_patient_sample_results,
			show_menu:this.state.show_menu,
			task_unit_entries:this.state.task_unit_entries,
			hiddeToReport:this.state.hiddeToReport,
			reload: this.reload,
			logo_1:this.state.logo_1,
			logo_2:this.state.logo_2,
			header_document:this.state.header_document,
			background_color:this.state.background_color,
			font_color:this.state.font_color,
			w_logo1:this.state.w_logo1,
			w_logo2:this.state.w_logo2,
			w_head:this.state.w_head,
			getLookFeel:this.getLookFeel,
			task_plasmatic_product:this.state.task_plasmatic_product,
			task_plasmatic_entries: this.state.task_plasmatic_entries,
			task_plasmatic_p_storage: this.state.task_plasmatic_p_storage,
			task_promotion_campaign: this.state.task_promotion_campaign,
			task_promotion_external_bags: this.state.task_promotion_external_bags,
			task_plasmatic_p_discard:this.state.task_plasmatic_p_discard,
			task_units_locked:this.state.task_units_locked,
			task_unit_transfer:this.state.task_unit_transfer,
			task_summary_campaigns:this.state.task_summary_campaigns,
			task_unit_delivered:this.state.task_unit_delivered,
			task_unit_reserves:this.state.task_unit_reserves,
			task_distribution_returned: this.state.task_distribution_returned,
			getDocumentType: this.getDocumentType,
			printDocumentTemplate: this.printDocumentTemplate,
			printDocumentExternal: this.printDocumentExternal,
			printLabel: this.printLabel,
			socket:socket,
			graphics:this.state.graphics,
			supplies_storage:this.state.supplies_storage,
			supplies_entries: this.state.supplies_entries,
			supplies: this.state.supplies,
			supplies_discards: this.state.supplies_discards,
			supplies_output: this.state.supplies_output,
			openSocket:this.openSocket,
			printPdfReports: this.printPdfReports,
			printPdfIMSSReports: this.printPdfIMSSReports,
			printExcelReport: this.printExcelReport,
			getServices: this.getServices,
			fetchRequest: fetchRequest,
			fileDownload: this.fileDownLoad,
			task_samples_reception:this.state.task_samples_reception
		};

		var min = sessionStorage.getItem('min_logout') !== null ? 1000 * 60 * parseInt(sessionStorage.getItem('min_logout')) : 1000 * 60 * 1;
		
		return (
		<div>
		<IdleTimer
				ref={ref => this.idleTimer = ref}
				element={document}
				onIdle ={()=>this.onIdle()}
				debounce={500}
				timeout={min} />
				
					<div className="App col-md-12" style={{padding:'0px'}}>
					
					{this.state.isAuthenticated && sessionStorage.getItem('interfaz') === 'web' && !this.state.passwordExpired ? 
						<div className="col-md-12" style={{padding:'0px', background:'white'}}>
							<Menu onClick={this.handleClick} onOpenChange={onOpenChange} mode='horizontal'>
								<MenuItem  key={100} search="logo" className="home">
									<div className="img-container">
										<Link to={'/'}>
											<img id='logo_img' src={this.state.logo_1} alt=""/>
										</Link>
									</div>
								</MenuItem>
								
								{header.menu.map((menu, i)=>
									this.state.show_menu[menu.permission] &&
										<SubMenu key={i} title={
											menu.show_icon ?
												<div 
												style={
													menu.permission === 'warehouse' ?
														this.state.line_warehouse ?
															{borderBottom:'3px solid red'} :
															{borderBottom:'0px solid red'} :
													menu.permission === 'distribution' ?
														this.state.line_unit_request && this.state.line_distribution_criteria === "YES" ?
															{borderBottom:'3px solid red'} :
															{borderBottom:'0px solid red'} :
														{borderBottom:'0px solid red'}
												}
												>
													<SvgIcon icon={
														menu.permission === 'donors' ?
															userPlus
														: menu.permission === 'laboratory' ?
															lab
														: menu.permission === 'processed' ?
															cogs
														: menu.permission === 'warehouse' ?
															eyedropper
														: menu.permission === 'distribution' ?
															ic_cached
														: menu.permission === 'patients' ?
															users
														: null
													} className="menu-icon"/>
													<span>{menu.title}</span>
												</div>
											:
												<span>{menu.title}</span>
											}
											popupOffset={[0, 0]}
										>
											{menu.submenu.map((submenu, j)=>
												(submenu.report && this.state.hiddeToReport) ?
													submenu.title !== "" ?										
														<SubMenu key={i+'-'+j} title={<span className="submenu-title-wrapper">{submenu.title}</span>}>
															{submenu.submenu.map((s, k)=>
																s.specify ?
																	childProps.task_has_user_profiles !== null ?
																		childProps.task_has_user_profiles.map((user)=>
																			user !== undefined &&
																				user === s.permission &&
																					<MenuItem key={i+'-'+j+'-'+k} search={s.search}>
																						<Link to={s.link}>
																							{s.title}
																						</Link>
																					</MenuItem>
																		)
																	: null
																:null
															)}
														</SubMenu>
													:
														submenu.submenu.map((s, k)=>
															s.specify ?
																childProps.task_has_user_profiles !== null ?
																	childProps.task_has_user_profiles.map((user)=>
																		user !== undefined &&
																			user === s.permission &&
																				<MenuItem key={i+'-'+j+'-'+k} search={s.search}>
																					<Link to={s.link}>
																						{s.title}
																					</Link>
																				</MenuItem>
																	)
																: null
															:null
														)
												: (!submenu.report && !this.state.hiddeToReport) ?
													submenu.submenu.map((s, k)=>
														s.specify ?
															childProps.task_has_user_profiles !== null ?
																childProps.task_has_user_profiles.map((user)=>
																	user !== undefined &&
																		user === s.permission &&
																			<MenuItem key={i+'-'+j+'-'+k} search={s.search}>
																				<Link to={s.link}>
																					{user.type === 'UNITS_EXPIRED' ?
																						<div style={this.state.line_warehouse ? 
																							{borderBottom:'3px solid red'} 
																							: {borderBottom:'0px solid red'}}>
																							{s.title}
																						</div>
																					: 
																						s.title
																					}
																				</Link>
																			</MenuItem>
																)
															: null
														:
															s.special === undefined ?
																childProps[s.permission][s.type_permission] &&
																	<MenuItem key={i+'-'+j+'-'+k} search={s.search}>
																		<Link to={s.link}>
																			{s.permission === 'task_unit_request'  ?
																				<div style={this.state.line_unit_request ? 
																					{borderBottom:'3px solid red'} 
																					: {borderBottom:'0px solid red'}}>
																					{s.title}
																				</div>
																			:
																				s.title
																			}
																		</Link>
																	</MenuItem>
															: 
																childProps.task_has_user_profiles.findIndex(item => item.indexOf('EPIDEMI_') !== -1) !== -1 &&
																	<MenuItem key={i+'-'+j+'-'+k} search={s.search}>
																		<Link to={s.link}>
																			{s.title}
																		</Link>
																	</MenuItem>
													)
												
												: null
												
											)}
										</SubMenu>
								)}

								
								

								{this.state.show_menu.reports ?
									<MenuItem key="20" search="" onClick={this.generateReport} style={{cursor:"pointer"}}>
										<SvgIcon icon={this.state.hiddeToReport ? home : statsDots} style={{marginRight:"5px"}}/>
									</MenuItem>
								:null}

								<SubMenu key="21" popupOffset={[-105, 0]} title={
									<div>
										<SvgIcon icon={user} className="menu-icon"/>
										<span>{sessionStorage.getItem('user_name')}</span>
									</div>
								} style={{float:"right"}}>
									<MenuItem key="21-0" search="none">
										<Link to="" onClick={e => e.preventDefault()} style={{ pointerEvents: 'none' }}>
											<SvgIcon icon={desktop} className="menu-icon"/>
											Versión {this.state.api_version}
										</Link>
									</MenuItem>
									<MenuItem key="21-3" search="site_change">
										<Link to="">
											<SvgIcon icon={hospitalO} className="menu-icon"/>
											Cambia de Hospital
										</Link>
									</MenuItem>
									<MenuItem key="21-1" search="pass_change">
										<Link  onClick={this.changePwd} to="">
											<SvgIcon icon={cog} className="menu-icon"/>
											Cambio de Contraseña
										</Link>
									</MenuItem>
									{/* {sessionStorage.getItem('user_name').toUpperCase() === "MASTER1" ?
									<MenuItem key="21-5">
										<a href="http://firmausr.idbb.com.mx" target="_blank">
											
											Firma de Usuario
										</a>
									</MenuItem>
									:null} */}
									<MenuItem key="21-2" search="singout">
										<Link onClick={()=>this.handleLogout()} to="" className="logout">
											<SvgIcon icon={exit} className="menu-icon"/>
											SALIR
										</Link>
									</MenuItem>
									
								</SubMenu>

							</Menu>
						</div> 
					/**MENU HANDHELD */
					:this.state.isAuthenticated && sessionStorage.getItem("user_type") === "USER_HANDHELD" && sessionStorage.getItem('interfaz') === 'movil'  ? 
					<div>
						<ButtonToolbar style={{float:"right",paddingRight:"30px"}}>
							<ButtonGroup>
								<Button className="btn btn-info" onClick={this.goHome}>
									<SvgIcon icon={home}/>
								</Button>
								<Button className="btn btn-info" onClick={()=>this.handleLogout()}>
									<SvgIcon icon={forward}/>
								</Button>
							</ButtonGroup>
						</ButtonToolbar>
					</div>
					:null}

					<MuiThemeProvider className="col-md-12">
						<Routes childProps={childProps} />
					</MuiThemeProvider>
					<MuiThemeProvider className="col-md-12">
						<ModalPassword {...this.props} waiting={this.waiting_modal} onRef={ref => (this.modal_pwd = ref)}/>
					</MuiThemeProvider>
					<MuiThemeProvider className="col-md-12">
						<ModalSetInfoSession 
							{...this.props} 
							onRef={ref => (this.modal_set_info = ref)} 
							save={this.setInfoSession} 
							token={sessionStorage.getItem('token')}
							change={true}
						/>
					</MuiThemeProvider>

					<WaitingModal {...this.props} onRef={ref => (this.waiting_modal = ref)}/>
					
				</div>

				<PrintStatusWidget />
			</div>
		);
	}
}

export default withRouter(App);